<template>
  <md-card class="pb-24">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("daily_attendance.attendance_detail") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content class="md-layout">
      <div
        v-if="check_status"
        class="md-layout-item md-size-100 mt-4 md-layout p-0"
      >
        <div
          class="md-layout-item md-size-20"
          v-for="(item, title) in percent_status"
          :key="title"
        >
          <result-box-custom
            class="h-full"
            :numberStudent="`${item.number} (${item.percent}%)`"
            :title="title"
          ></result-box-custom>
        </div>
      </div>
      <div v-if="detail.total" class="md-layout-item md-size-100 mt-6 w-full">
        <md-table>
          <md-table-row>
            <md-table-head>
              <p class="cell date-time-cell font-semibold">
                {{ $t("common.date_time") }}
              </p>
            </md-table-head>
            <md-table-head>
              <p class="cell status-cell font-semibold">
                {{ $t("common.status") }}
              </p>
            </md-table-head>
            <md-table-head>
              <p class="cell status-cell font-semibold">
                {{ $t("smi_sri.comment") }}
              </p>
            </md-table-head>
          </md-table-row>
          <md-table-row
            v-for="(item, index) in detail.data"
            :key="index + item.status"
            class="h-24"
          >
            <md-table-cell>
              <p>
                {{ convertDateFromServer(item.end, "date") }}
              </p></md-table-cell
            >
            <md-table-cell>
              <div class="text-center w-[200px]">
                <p
                  :style="{
                    color: setColorAttendanceStatus(item.status),
                    'background-color': setBgColorAttendanceStatus(item.status),
                    'font-weight': 'bold'
                  }"
                  class="px-3 py-2 rounded-2xl"
                >
                  {{ generateStatus(item.status) }}
                </p>
              </div>
            </md-table-cell>
            <md-table-cell>
              <p>
                {{ item.description }}
              </p>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <div v-else class="flex justify-center items-center w-full my-4">
        <no-data-found
          :description="
            `${
              check_status ? $t('common.no_results') : $t('common.no_date_time')
            }`
          "
        ></no-data-found>
      </div>
      <div
        class="md-layout-item md-size-100 mt-6 flex items-center justify-center"
        v-if="detail.total"
      >
        <Pagination
          :value="currentPage"
          :perPage="20"
          :total="detail.total"
          @input="changePage"
        />
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import ResultBoxCustom from "./ResultBoxCustom";
import Pagination from "@/components/Pagination";
import NoDataFound from "@/components/Base/Illustration/NoDataFound";
import { convertDateFromServer } from "@/helpers/datetime-helper";
import { generateStatus } from "@/helpers/text-helper";
import {
  setColorAttendanceStatus,
  setBgColorAttendanceStatus
} from "../../../../helpers/color";

export default {
  components: {
    NoDataFound,
    ResultBoxCustom,
    Pagination
  },
  data() {
    return {
      currentPage: 1,
      convertDateFromServer,
      generateStatus,
      setColorAttendanceStatus,
      setBgColorAttendanceStatus
    };
  },
  props: ["detail", "percent_status", "check_status"],
  methods: {
    changePage(val) {
      this.$emit("changePage", val);
      this.currentPage = val;
    },
    resetPage() {
      this.currentPage = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
thead tr * {
  @apply font-semibold;
}
.table-student {
  .table__body {
    tr {
      &:nth-child(2n) {
        background-color: #f7f9fc;
      }
    }
  }
}
</style>
